import CASL from '@/utils/constants/casl'

export default {
  path: 'option-library',
  children: [
    {
      path: '',
      name: 'option-library.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.OPTION_LIBRARY
      },
      component: () => import('./list/OptionLibraryListPage.vue')
    }
  ]
}
